export const metaData = {
  '1681': {
    desc:
      'Sikrer 100% dekning og rekkevidde. For deg som bor i enebolig, gammelt bygg, stor leilighet eller har Wifi-problemer enkelte steder i boligen'
  },
  '1605': {
    desc: ''
  },
  '2015': {
    desc: 'Spar 1500,-'
  }
};
//2015 apple tv
